export interface ApplicationState {
  application: ApplicationModel
  applications: ApplicationModel[]
  selectedRows: number
  currentPage: number
  logsInWeek: { date: string; errorLogs: number; successLogs: number }[]
  totalLogsInWeek: number
  successLogsInWeek: number
  errorLogsInWeek: number
  selectedApplicationIds: string[]
}

export interface ConfigApplicationModel {
  idAccessTokenLifeSpan?: number
  accessTokenLifeSpan?: number
  refreshTokenLifeSpan?: number
}

export const GET_APPLICATION = 'GET_APPLICATION'
export const GET_LIST_APPLICATIONS = 'GET_LIST_APPLICATIONS'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_SELECTED_ROWS = 'SET_SELECTED_ROWS'
export const GET_APPLICATION_LOGS_IN_WEEK = 'GET_APPLICATION_LOGS_IN_WEEK'
export const SELECTED_APPLICATION_IDS = 'SELECTED_APPLICATION_IDS'
